"use strict";

var _classCallCheck = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");

var sax_1 = __importDefault(require("sax"));

var parse_time_1 = require("./parse-time");
/**
 * A wrapper around sax that emits segments.
 */


var DashMPDParser = /*#__PURE__*/function (_stream_1$Writable) {
  _inherits(DashMPDParser, _stream_1$Writable);

  var _super = _createSuper(DashMPDParser);

  function DashMPDParser(targetID) {
    var _this;

    _classCallCheck(this, DashMPDParser);

    _this = _super.call(this);
    _this._parser = sax_1.default.createStream(false, {
      lowercase: true
    });

    _this._parser.on('error', _this.destroy.bind(_assertThisInitialized(_this)));

    var lastTag;
    var currtime = 0;
    var seq = 0;
    var segmentTemplate;
    var timescale, offset, duration, baseURL;
    var timeline = [];
    var getSegments = false;
    var gotSegments = false;
    var isStatic;
    var treeLevel;
    var periodStart;

    var tmpl = function tmpl(str) {
      var context = {
        RepresentationID: targetID,
        Number: seq,
        Time: currtime
      };
      return str.replace(/\$(\w+)\$/g, function (m, p1) {
        return "".concat(context[p1]);
      });
    };

    _this._parser.on('opentag', function (node) {
      switch (node.name) {
        case 'mpd':
          currtime = node.attributes.availabilitystarttime ? new Date(node.attributes.availabilitystarttime).getTime() : 0;
          isStatic = node.attributes.type !== 'dynamic';
          break;

        case 'period':
          // Reset everything on <Period> tag.
          seq = 0;
          timescale = 1000;
          duration = 0;
          offset = 0;
          baseURL = [];
          treeLevel = 0;
          periodStart = parse_time_1.durationStr(node.attributes.start) || 0;
          break;

        case 'segmentlist':
          seq = parseInt(node.attributes.startnumber) || seq;
          timescale = parseInt(node.attributes.timescale) || timescale;
          duration = parseInt(node.attributes.duration) || duration;
          offset = parseInt(node.attributes.presentationtimeoffset) || offset;
          break;

        case 'segmenttemplate':
          segmentTemplate = node.attributes;
          seq = parseInt(node.attributes.startnumber) || seq;
          timescale = parseInt(node.attributes.timescale) || timescale;
          break;

        case 'segmenttimeline':
        case 'baseurl':
          lastTag = node.name;
          break;

        case 's':
          timeline.push({
            duration: parseInt(node.attributes.d),
            repeat: parseInt(node.attributes.r),
            time: parseInt(node.attributes.t)
          });
          break;

        case 'adaptationset':
        case 'representation':
          treeLevel++;

          if (!targetID) {
            targetID = node.attributes.id;
          }

          getSegments = node.attributes.id === "".concat(targetID);

          if (getSegments) {
            if (periodStart) {
              currtime += periodStart;
            }

            if (offset) {
              currtime -= offset / timescale * 1000;
            }

            _this.emit('starttime', currtime);
          }

          break;

        case 'initialization':
          if (getSegments) {
            _this.emit('item', {
              url: baseURL.filter(function (s) {
                return !!s;
              }).join('') + node.attributes.sourceurl,
              seq: seq,
              init: true,
              duration: 0
            });
          }

          break;

        case 'segmenturl':
          if (getSegments) {
            gotSegments = true;
            var tl = timeline.shift();
            var segmentDuration = ((tl === null || tl === void 0 ? void 0 : tl.duration) || duration) / timescale * 1000;

            _this.emit('item', {
              url: baseURL.filter(function (s) {
                return !!s;
              }).join('') + node.attributes.media,
              seq: seq++,
              duration: segmentDuration
            });

            currtime += segmentDuration;
          }

          break;
      }
    });

    var onEnd = function onEnd() {
      if (isStatic) {
        _this.emit('endlist');
      }

      if (!getSegments) {
        _this.destroy(Error("Representation '".concat(targetID, "' not found")));
      } else {
        _this.emit('end');
      }
    };

    _this._parser.on('closetag', function (tagName) {
      switch (tagName) {
        case 'adaptationset':
        case 'representation':
          treeLevel--;

          if (segmentTemplate && timeline.length) {
            gotSegments = true;

            if (segmentTemplate.initialization) {
              _this.emit('item', {
                url: baseURL.filter(function (s) {
                  return !!s;
                }).join('') + tmpl(segmentTemplate.initialization),
                seq: seq,
                init: true,
                duration: 0
              });
            }

            var _iterator = _createForOfIteratorHelper(timeline),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _step$value = _step.value,
                    itemDuration = _step$value.duration,
                    repeat = _step$value.repeat,
                    time = _step$value.time;
                itemDuration = itemDuration / timescale * 1000;
                repeat = repeat || 1;
                currtime = time || currtime;

                for (var i = 0; i < repeat; i++) {
                  _this.emit('item', {
                    url: baseURL.filter(function (s) {
                      return !!s;
                    }).join('') + tmpl(segmentTemplate.media),
                    seq: seq++,
                    duration: itemDuration
                  });

                  currtime += itemDuration;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          if (gotSegments) {
            _this.emit('endearly');

            onEnd();

            _this._parser.removeAllListeners();

            _this.removeAllListeners('finish');
          }

          break;
      }
    });

    _this._parser.on('text', function (text) {
      if (lastTag === 'baseurl') {
        baseURL[treeLevel] = text;
        lastTag = null;
      }
    });

    _this.on('finish', onEnd);

    return _this;
  }

  _createClass(DashMPDParser, [{
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      this._parser.write(chunk, encoding);

      callback();
    }
  }]);

  return DashMPDParser;
}(stream_1.Writable);

exports.default = DashMPDParser;